module.exports = __webpack_public_path__ + "static/media/02.b6314862.png";